import { CSSProperties } from "react";

import { BaseReactComponent } from "@/Common/Components/BaseReactComponent";
import { CheckedListControl } from "@/Common/Components/Inputs/CheckedListControl";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface ILabActionNotesTooltipControl {
    ControlId: string;
    Value: string;

    actionSecretaryCheckboxes: Immutable.List<CheckboxUIModel>;
    actionNursesCheckboxes: Immutable.List<CheckboxUIModel>;

    ReferenceId: string;

    Target?: number;
    SubReferenceId?: string;

    EventToDispatchToClosePopup: number;
    leftPosition: number;
    topPosition: number;
}

class LabActionNotesTooltipControl extends BaseReactComponent<ILabActionNotesTooltipControl> {
    public render(): JSX.Element {
        const style: CSSProperties = {
            position: "absolute",
            left: this.props.leftPosition + "px",
            top: this.props.topPosition + "px"
        };
        return (

            <div id={this.props.ControlId} onClick={this.cancelClickPropagation} data-dropdown-content className="notes-modal" aria-hidden="false" style={style} aria-autoclose="false">
                <div className="notes-dropdown-content">
                    <div>
                        <h4 className="thin-font">{"Actions : "}</h4>

                        <div className="row">

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="row"><span>{cacheStore.GetString("SecretaryLabel")}</span></div>
                                <CheckedListControl DataSource={this.props.actionSecretaryCheckboxes} Operation={LocalOperations.LabsUI.ActionCheckBoxClick} sort={false} />
                            </div>

                            <div className="col-lg-6 col-md-6 col-sm-6">
                                <div className="row"><span>{cacheStore.GetString("NurseLabel")}</span></div>
                                <CheckedListControl DataSource={this.props.actionNursesCheckboxes} Operation={LocalOperations.LabsUI.ActionCheckBoxClick} sort={false} />
                            </div>

                        </div>

                    </div>

                    <h4 className="thin-font">{cacheStore.GetString("AddNoteLabel").toUpperCase()}</h4>
                    <textarea className="form-control" value={this.props.Value} id="memo_doctb" onChange={e => this.OnTexboxChange(e)} rows={4} />
                </div>
                <div className="notes-content-footer text-right">
                    <button className="btn btn-primary" disabled={false} onClick={() => this.SubmitNote()}>{cacheStore.GetString("NoteSubmitLabel")}</button>
                </div>
            </div>
        );
    }

    public SubmitNote(): void {
        const operation = new LocalEvent(LocalOperations.LabsUI.ActionNote_Save);
        operation.AddItem("ReferenceId", this.props.ReferenceId);
        operation.AddItem("Target", this.props.Target);
        operation.AddItem("SubReferenceId", this.props.SubReferenceId);
        operation.AddItem("value", this.props.Value);
        LocalEventDispatcher.dispatch(operation);
    }

    public shouldComponentUpdate(nextProp: ILabActionNotesTooltipControl): boolean {
        const id_mismatch = this.props.ReferenceId !== nextProp.ReferenceId;
        const subid_mismatch = this.props.SubReferenceId !== nextProp.SubReferenceId;
        const subTarget_mismatch = this.props.Target !== nextProp.Target;
        const checkboxesNurse_mismatch = this.props.actionNursesCheckboxes != nextProp.actionNursesCheckboxes;
        const checkboxesSecretary_mismatch = this.props.actionSecretaryCheckboxes != nextProp.actionSecretaryCheckboxes;
        const text_changed = this.props.Value !== nextProp.Value;
        const position = this.props.leftPosition !== nextProp.leftPosition || this.props.topPosition !== nextProp.topPosition;
        return id_mismatch || text_changed || position || subid_mismatch || subTarget_mismatch || checkboxesNurse_mismatch || checkboxesSecretary_mismatch;
    }

    public componentDidMount(): void {
        this.setOverlay("ActionsNotesPopup");

        $("#" + this.props.ControlId).on("opened.fndtn.dropdown", function() { $(this).find("textarea").css({ height: "40px" }); });
        $("#" + this.props.ControlId).on("closed.fndtn.dropdown", function() {
            if (this.props.EventToDispatchOnDropdownClosed != null) {
                const operation = new LocalEvent(this.props.EventToDispatchOnDropdownClosed);
                LocalEventDispatcher.dispatch(operation);
            }
        });

        const elem = document.getElementById("memo_doctb");
        elem.focus();
    }

    private cancelClickPropagation(e: React.MouseEvent): void {
        e.stopPropagation();
    }

    private OnTexboxChange(e: React.ChangeEvent<HTMLTextAreaElement>): void {
        const operation = new LocalEvent(LocalOperations.LabsUI.ActionNote_Text_Changed);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
    }
}

export { LabActionNotesTooltipControl };
